import React, {useEffect, useState} from 'react'
import ReactImageMagnify from 'react-image-magnify'
import Slider from 'react-slick'
import PdfViewer from './PDFViewer'
import '../../shared-css/slickoverride.css'

type PreviewCustomerBillProps = {
  urls?: Array<string>
  files?: Array<File>
  previewSettings: {isFluidWidth: boolean; width: number; height: number}
  isDeletable?: boolean
  deleteHandler?: any
}

const settings = {
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: false,
}

const PreviewCustomerBill = ({
  urls = [],
  files = [],
  previewSettings,
  isDeletable = false,
  deleteHandler,
}: PreviewCustomerBillProps) => {
  const [fileUrls, setFileUrls] = useState<Array<{file: File; url: string}>>([])

  useEffect(() => {
    const newFileUrls = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }))
    setFileUrls(newFileUrls)

    return () => {
      newFileUrls.forEach((fileObj) => URL.revokeObjectURL(fileObj.url))
    }
  }, [files])

  const allItems = [
    ...urls.map((url) => ({
      type: url?.split('.').slice(-1)[0],
      src: `${process.env.REACT_APP_IMAGE_BASE_URL}${url}`,
      name:null

    })),
    ...fileUrls.map((fileObj) => ({
      type: fileObj.file?.type,
      src: fileObj.url,
      file: fileObj.file,
      name:fileObj.file?.name
    })),
  ]

  return (
    <>
      <Slider {...settings}>
        {allItems.map((item, index) =>
          item?.type.includes('pdf') ? (
            <div key={index}>
              {isDeletable && (
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary float-end position-relative'
                  style={{zIndex: 15}}
                  onClick={() => deleteHandler(item?.src,item?.name)}
                >
                  <svg
                    width='14'
                    height='14'
                    viewBox='0 0 14 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      opacity='0.5'
                      d='M7.00002 5.76278L5.76282 6.99998L0.256396 12.5059C-0.0854139 12.8476 -0.0854139
                    13.4018 0.256396 13.7436C0.598179 14.0854 1.15236 14.0854 1.49417 13.7436L7.00002
                    8.23718L8.23722 6.99998L13.7436 1.49413C14.0855 1.15235 14.0854 0.598168 13.7436
                    0.256358C13.4019 -0.0854526 12.8477 -0.0854526 12.5059 0.256358L7.00002 5.76278Z'
                      fill='#7E8299'
                    ></path>

                    <path
                      d='M6.99998 5.76278L8.23718 6.99998L13.7436 12.5059C14.0854 12.8476 14.0854 13.4018
                    13.7436 13.7436C13.4018 14.0854 12.8476 14.0854 12.5058 13.7436L6.99998 8.23718L5.76278
                    6.99998L0.256358 1.49413C-0.0854526 1.15235 -0.0854252 0.598168 0.256358 0.256358C0.598141
                    -0.0854526 1.15232 -0.0854526 1.49413 0.256358L6.99998 5.76278Z'
                      fill='#7E8299'
                    ></path>
                  </svg>
                </div>
              )}
              <PdfViewer url={item.src} previewSettings={previewSettings} />
            </div>
          ) : (
            <div key={index}  className='Testdev'>
              {isDeletable && (
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary float-end text-end position-relative'
                  onClick={() => deleteHandler(item?.src,item?.name)}
                  style={{zIndex: 15}}
                >
                  <svg
                    width='14'
                    height='14'
                    viewBox='0 0 14 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      opacity='0.5'
                      d='M7.00002 5.76278L5.76282 6.99998L0.256396 12.5059C-0.0854139 12.8476 -0.0854139
                    13.4018 0.256396 13.7436C0.598179 14.0854 1.15236 14.0854 1.49417 13.7436L7.00002
                    8.23718L8.23722 6.99998L13.7436 1.49413C14.0855 1.15235 14.0854 0.598168 13.7436
                    0.256358C13.4019 -0.0854526 12.8477 -0.0854526 12.5059 0.256358L7.00002 5.76278Z'
                      fill='#7E8299'
                    ></path>

                    <path
                      d='M6.99998 5.76278L8.23718 6.99998L13.7436 12.5059C14.0854 12.8476 14.0854 13.4018
                    13.7436 13.7436C13.4018 14.0854 12.8476 14.0854 12.5058 13.7436L6.99998 8.23718L5.76278
                    6.99998L0.256358 1.49413C-0.0854526 1.15235 -0.0854252 0.598168 0.256358 0.256358C0.598141
                    -0.0854526 1.15232 -0.0854526 1.49413 0.256358L6.99998 5.76278Z'
                      fill='#7E8299'
                    ></path>
                  </svg>
                </div>
              )}
              <ReactImageMagnify
                  isHintEnabled
                  enlargedImagePosition='over'
                  enlargedImageContainerDimensions={{ width: '100%', height: '100%' }}
                  imageStyle={{ height: '500px !important', width: '100%', objectFit: 'contain'}}
                  enlargedImageStyle={{ height: '400px' }}             
                  {...{
                  smallImage: {
                    alt: 'Preview Image',
                    isFluidWidth: previewSettings.isFluidWidth,
                    width: previewSettings.width,
                    height: 300,
                    src: item.src,
                  },
                  largeImage: {
                    src: item.src,
                    width: 600,
                    height: 1800,
                  },
                }}
              />
            </div>
          )
        )}
      </Slider>
    </>
  )
}

export default PreviewCustomerBill
